import { usePermissionStore } from "@/core/stores/permission.store"
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Button, Popconfirm } from "antd"

interface SaveButtonProps {
    onClick: () => any,
    loading: boolean,
    isEdit: boolean
}
export const SaveButton: React.FC<SaveButtonProps> = ({onClick, loading, isEdit}) => {
    const permissionStore = usePermissionStore();
    if (isEdit&&!permissionStore.page.edit) return null;
    if (!isEdit&&!permissionStore.page.add) return null;
    return <Popconfirm
        title={`Lưu thay đổi?`}
        description={`Bạn có chắc chắn muốn lưu thay đổi?`}
        onConfirm={onClick}
        okText="Lưu thay đổi"
        cancelText="Hủy"
        okButtonProps={{style: {backgroundColor: "var(--primary-color)"}}}
        icon={<ExclamationCircleFilled style={{color: "var(--danger-color)"}} />}
    >
        <Button key="submit" type="primary" loading={loading}
            style={{ 
                background: "var(--primary-color)", 
                paddingRight: 48, 
                paddingLeft: 48, 
                fontSize: 18,
                fontWeight: 600,
                paddingTop: 18, 
                paddingBottom: 18,
                }}
        >
            LƯU
        </Button>
    </Popconfirm>
    
}